jQuery(document).ready(function ($) {
	if ($("#type input").is(':checked')) {
		$("#type").addClass("visible");
	}

	if ($("#topic input").is(':checked')) {
		$("#topic").addClass("visible");
	}

	if ($("#collection input").is(':checked')) {
		$("#collection").addClass("visible");
	}

	if ($("#year input").is(':checked')) {
		$("#year").addClass("visible");
	}

	$('.resource-form-type').change(function () {
		$('.resource-form-type').submit();
	});

	$('.resource-form-topic').change(function () {
		$('.resource-form-topic').submit();
	});

	$('.resource-form-collection').change(function () {
		$('.resource-form-collection').submit();
	});

	$('.resource-form-year').change(function () {
		$('.resource-form-year').submit();
	});

	$('.resource-form-sort-by').change(function () {
		$('.resource-form-sort-by').submit();
	});

	$('.show').click(function () {
		if ($(this).text() == "Hide") {
			$(this).text("Show")
		} else {
			$(this).text("Hide")
		}
	});

});
